import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  addNewItem,
  getItemsdData,
} from "../../util/APIUtils";
import "react-datepicker/dist/react-datepicker.css";
import { LoadingOverlay } from "../../util/Helpers";
import StockDetailsBody from "./StockDetailsBody";
import AddItemForm from "./AddItemForm";
import { CardBody, CardHeader, Card } from "reactstrap";
import { FaArrowLeft } from "react-icons/fa";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

export default function StockDetails() {
  const [block, setBlock] = useState(false);
  const [items, setItems] = useState([]);
  const [flag, setFlag] = useState(false);
  const [values, setValues] = useState({});
  const [modal, setModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [restRow, setRestRow] = useState(null);

  useEffect(() => {
    loadReqData();
  }, []);

  const loadReqData = useCallback(() => {
    setBlock(true);
    getItemsdData().then((response) => {
      setItems(response);
      setBlock(false);
    });
  }, []);

  const onChangeForm = useCallback(({ target: { name, value } }) => {
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  }, []);

  const addItem = useCallback((data) => {
    setBlock(true);
    addNewItem(data).then(() => {
      setBlock(false);
      loadReqData();
    });
  }, [loadReqData]);

  const updateDetails = useCallback((row) => {
    toggleModal();
    setSelectedRow(row);
    setRestRow(row);
  }, []);

  const toggleModal = useCallback(() => setModal((prev) => !prev), []);

  const changeFlag = useCallback(() => {
    setFlag((prev) => !prev);
  }, []);

  const handleInputChange = useCallback(({ target: { name, value } }) => {
    if (!selectedRow) return;
    setSelectedRow((prevRow) => ({
      ...prevRow,
      [name]: value,
    }));
  }, [selectedRow]);

  const memoizedItems = useMemo(() => items, [items]);

  return (
    <div className="animated fadeIn">
      {block && <LoadingOverlay />}
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Update Stock Details</ModalHeader>
        <ModalBody>
          <Form>
            {[
              { label: "Item Code", name: "itemCode", readOnly: true },
              { label: "Purchase Price", name: "purchasePrice", required: true },
              { label: "Sale Price", name: "salePrice", required: true },
              { label: "MRP", name: "mrp", required: true },
              { label: "In Stock", name: "inStock", required: true },
              { label: "Stock Value", name: "stockValue", required: true },
            ].map(({ label, name, readOnly, required }) => (
              <FormGroup key={name} className="d-flex align-items-center">
                <Label for={name} className="mr-2 w-25">
                  {label}
                </Label>
                <Input
                  type="text"
                  name={name}
                  id={name}
                  value={selectedRow ? selectedRow[name] : ""}
                  onChange={handleInputChange}
                  className="w-75"
                  readOnly={readOnly}
                  required={required}
                  autoComplete="off"
                  onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))} // Allow only numbers and decimal point
                />
              </FormGroup>
            ))}
            <div className="d-flex justify-content-center mt-3">
              <Button
                color="primary"
                className="mr-2"
                onClick={() => {
                  if (!selectedRow) {
                    swal("Error", "No data selected for update.", "error");
                    return;
                  }

                  const requiredFields = [
                    "purchasePrice",
                    "salePrice",
                    "mrp",
                    "inStock",
                    "stockValue",
                  ];

                  const missingFields = requiredFields.filter(
                    (key) => !selectedRow[key]
                  );

                  if (missingFields.length > 0) {
                    swal(
                      "Error",
                      `Please fill out the following fields: ${missingFields.join(", ")}`,
                      "error"
                    );
                    return;
                  }
                  addItem(selectedRow);
                  toggleModal();
                }}
              >
                Update
              </Button>
              <Button
                color="warning"
                onClick={() => {
                  setSelectedRow(restRow);
                }}
              >
                Reset
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      {flag ? (
        <Card style={{
          borderRadius: "15px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
          border: "none",
          overflow: "hidden"
        }}>
          <CardHeader style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "20px 25px",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: "none"
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <i className="fa fa-cube" style={{ fontSize: "24px", color: "#fff" }}></i>
              <strong style={{ fontSize: '1.2rem', color: "#fff" }}>Add Item</strong>
            </div>
            <Button
              color="secondary"
              onClick={changeFlag}
              style={{
                background: "rgba(255,255,255,0.2)",
                border: "1px solid rgba(255,255,255,0.3)",
                borderRadius: "8px",
                color: "#fff"
              }}
            >
              <FaArrowLeft /> Back
            </Button>
          </CardHeader>
          <CardBody style={{ padding: "25px" }}>
            <AddItemForm addItem={addItem} onChangeForm={onChangeForm} values={values} />
          </CardBody>
        </Card>
      ) : (
        <StockDetailsBody
          data={memoizedItems}
          updateDetails={updateDetails}
          changeFlag={changeFlag}
        />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/StockDetails.js